import { useRouter } from 'next/router';
import { Routes } from 'services/routes';
import { useIsLoggedIn } from './useIsLoggedIn';

export const useRequireAuth = (): void => {
  const router = useRouter();
  if (useIsLoggedIn() === false) void router.push(Routes.logIn(router.asPath));
};
